<template>
    <div class="empty nibnut-offline">
        <div class="empty-icon">
            <open-icon glyph="hiking" size="5x" />
        </div>
        <p class="empty-title h5">{{ $root.translate("Off the beaten path, are we?") }}</p>
        <p class="empty-subtitle">{{ $root.translate("You are currently offline - good for you! Your app will be right back as soon as it can grab a network...") }}</p>
    </div>
</template>

<script>
import OpenIcon from "@/nibnut/components/OpenIcon"

export default {
    name: "Offline",
    components: {
        OpenIcon
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/variables";

.nibnut-offline {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: $zindex-offline;
}
</style>
